export function isSameClerkId(a, b) {
  return !!a && !!b && String(a) === String(b);
}

const DILIGENT_ADMIN_ROLES = new Set([
  "Administrator",
  "Admin",
  "Backend User",
]);

export function getVendorSelfProfileRedirectPath(userRole) {
  if (userRole === "Provider User") return "/Provider/Users/Me";
  if (DILIGENT_ADMIN_ROLES.has(userRole) || userRole === "Provider Master User") {
    return "/Backend/Users/Me";
  }
  return null;
}

export function getSponsorSelfProfileRedirectPath(userRole) {
  if (userRole === "Sponsor User" || userRole === "Sponsor Master User") {
    return "/Sponsor/Users/Me";
  }
  if (DILIGENT_ADMIN_ROLES.has(userRole) || userRole === "Backend Master User") {
    return "/Backend/Users/Me";
  }
  return null;
}

export function getVendorUserFormCopy({ isEditingSelf, userId } = {}) {
  if (isEditingSelf) {
    return {
      title: "Manage my profile",
      description: "Update your personal information below.",
    };
  }
  if (userId) {
    return {
      title: "Edit Vendor User",
      description: "Update the information for this vendor user account.",
    };
  }
  return {
    title: "Add New Vendor User",
    description: "Fill in the information below to create a new vendor user account.",
  };
}
